import { Injectable } from '@angular/core';
import { BusinessUnitPos } from './model/portal.data.model';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  get SelectedBusinessUnit(): number {
    return Number.parseInt(localStorage.getItem('selectedBusinessUnit'));
  }

  set SelectedBusinessUnit(value: number) {
    localStorage.setItem('selectedBusinessUnit', value.toString());
  }

  get SelectedBusinessUnitName(): string {
    return localStorage.getItem('selectedBusinessUnitName');
  }

  set SelectedBusinessUnitName(value: string) {
    localStorage.setItem('selectedBusinessUnitName', value);
  }

  get SelectedPos(): BusinessUnitPos {
    var pos = JSON.parse(
      localStorage.getItem('selectedPos')
    ) as BusinessUnitPos;
    if (pos != null)
      return JSON.parse(localStorage.getItem('selectedPos')) as BusinessUnitPos;
    return {} as BusinessUnitPos;
  }

  set SelectedPos(value: BusinessUnitPos) {
    localStorage.setItem('selectedPos', JSON.stringify(value));
  }

  get IsPosOnline(): boolean {
    return localStorage.getItem('isPosOnline') == 'true';
  }

  set IsPosOnline(value: boolean) {
    localStorage.setItem('isPosOnline', value.toString());
  }
 }
